module.exports = __webpack_public_path__ + "img/202501160201.59f32c85.png";